<template>
    <NuxtLayout :name="layoutName">
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useAuth, useRoute} from '#imports';

    const route = useRoute();

    const layoutName = computed(() => {
        if (
            (!loggedIn.value && !route.path.includes('/signin')) ||
            route.name === 'index' ||
            route.path.includes('/pdf') ||
            route.path.includes('/umbrella')
        ) {
            return false;
        } else {
            return isUmbrellaCompany.value ? 'funnel' : 'malt-full-layout';
        }
    });

    const authStore = useAuth();
    const {loggedIn, isUmbrellaCompany} = storeToRefs(authStore);
</script>
